import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo/office-design-logo-white.png'


const _hoisted_1 = { class: "container-fluid p-0" }
const _hoisted_2 = { class: "row m-0" }
const _hoisted_3 = { class: "col-12 p-0" }
const _hoisted_4 = { class: "login-card login-dark" }
const _hoisted_5 = { class: "login-main" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-input position-relative" }
const _hoisted_9 = ["type"]

import { ref } from "vue"
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import { useRouter } from 'vue-router'
import { directus } from "@/services/directus"
import { readUsers } from "@directus/sdk"


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

let router = useRouter()
let type = ref<string>('password')
let email = ref<string>("")
let password = ref<string>("")

function showPassword() {
    if (type.value === 'password') {
        type.value = 'text';
    } else {
        type.value = 'password';
    }
}

async function doLogin() {
    if (email.value && password.value) {
        try {
            await directus.login(email.value, password.value);
            const response = await directus.request(
                readUsers({
                    filter: {
                        email: { _eq: email.value },
                    },
                    fields: ["*"],
                })
            );
            const login = response[0]

            localStorage.setItem('user_first_name', login.first_name)
            localStorage.setItem('user_last_name', login.last_name)
            localStorage.setItem('user_full_name', `${login.first_name} ${login.last_name}`)
            localStorage.setItem('user', email.value)
            localStorage.setItem("SidebarType", 'compact-wrapper')
            router.replace('/receipt/list_stock');
            toast.success('Login Successfully ', { position: 'top-right', autoClose: 2000 });
        } catch(err: any) {
            toast.error('Login failed: ' + (err?.message || 'Unknown error'), { position: 'top-right', autoClose: 2000 });
        }
    }
    else {
        toast.error('Opps... Invalid email and password ', { position: 'top-right', autoClose: 2000 });
    }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("div", null, [
              _createVNode(_component_router_link, {
                class: "logo",
                to: "/"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createElementVNode("img", {
                    class: "img-fluid for-light",
                    style: {"width":"28vh"},
                    src: _imports_0,
                    alt: "looginpage"
                  }, null, -1),
                  _createElementVNode("img", {
                    class: "img-fluid for-dark",
                    src: _imports_0,
                    alt: "looginpage"
                  }, null, -1)
                ])),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("form", {
                class: "theme-form",
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
              }, [
                _cache[7] || (_cache[7] = _createElementVNode("h4", null, "Sign in to account", -1)),
                _cache[8] || (_cache[8] = _createElementVNode("p", null, "Enter your email & password to login", -1)),
                _createElementVNode("div", _hoisted_6, [
                  _cache[4] || (_cache[4] = _createElementVNode("label", { class: "col-form-label" }, "Email Address", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : email = $event)),
                    class: "form-control",
                    type: "email"
                  }, null, 512), [
                    [_vModelText, _unref(email)]
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", { class: "col-form-label" }, "Password", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(password) ? (password).value = $event : password = $event)),
                      type: _unref(type),
                      class: "form-control",
                      name: "login[password]"
                    }, null, 8, _hoisted_9), [
                      [_vModelDynamic, _unref(password)]
                    ]),
                    _createElementVNode("div", { class: "show-hide" }, [
                      _createElementVNode("span", {
                        class: "show",
                        onClick: showPassword
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "form-group mb-0" }, [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "checkbox p-0" }, [
                    _createElementVNode("input", {
                      id: "checkbox1",
                      type: "checkbox"
                    }),
                    _createElementVNode("label", {
                      class: "text-muted",
                      for: "checkbox1"
                    }, "Remember password")
                  ], -1)),
                  _createElementVNode("div", { class: "text-end mt-3" }, [
                    _createElementVNode("button", {
                      class: "btn btn-primary btn-block w-100",
                      type: "submit",
                      onClick: doLogin
                    }, "Sign in")
                  ])
                ])
              ], 32)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})